module.exports = __webpack_public_path__ + "static/img/rq_code_dow.f047152.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rq_code_dow.png
// module id = jot/
// module chunks = 1